import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import { Layout } from 'antd';
import ScrollToTopOnMount from '../scroll_to_top_on_mount/ScrollToTopOnMount';
import SubnavTabs from '../subnav_tabs/SubnavTabs';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';

const { Content } = Layout;
const style = require('./SupplierInvoicesOverviewPage.less');

class SupplierInvoicesOverviewPage extends React.Component<any, any> {
	handleTabChange = (key) => {
		const { history, match } = this.props;
		const path = nullSafeGetOrElse('path', match, '/supplier/invoices');
		history.push(`${path}/${key}`);
	};

	checkTabActive = (key) => {
		const { history } = this.props;
		const pathname = history.location.pathname;
		return pathname.indexOf(key) !== -1;
	};

	render() {
		const { companyConfig, match } = this.props;
		const tabs = [
			{
				key: 'all',
				name: 'All',
			},
		];
		const path = nullSafeGetOrElse('path', match, '/supplier/invoices');

		return (
			<div>
				<ScrollToTopOnMount />
				<div>
					<Route
						path={`${path}`}
						exact={true}
						render={(props) => (
							<Redirect
								to={{
									pathname: `${path}/all`,
								}}
							/>
						)}
					/>
					<Content className="invoicesPage" style={{ padding: '0 0.5em' }}>
						{/*<ScrollToTopOnMount/>*/}
						{/*<BackTop/>*/}

						<div
							style={{
								margin: '0 -8px',
								padding: '24px',
								paddingBottom: 0,
								background: nullSafeGet('detail.config.theme.navblock', companyConfig),
								marginBottom: 8,
							}}
						>
							<h4
								style={{
									color: 'rgba(255, 255, 255, 0.9)',
									marginRight: 8,
									marginBottom: 24,
								}}
							>
								Invoices
							</h4>
							<SubnavTabs
								tabs={tabs}
								onChange={this.handleTabChange}
								isActive={this.checkTabActive}
							/>
						</div>
						{this.props.childRoutes.map((r, i) => (
							<RouteWithSubRoutes key={i} {...r} />
						))}
					</Content>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	companyConfig: state.company_config,
});
const mapDispatchToProps = (dispatch) => ({});
export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(SupplierInvoicesOverviewPage)
);
